import { converToStorageUnit } from '../utils';

let domain;
let hostApi;
let hostS3;

const hostname = window.location.hostname.split('.')[0];

// Check if hostname is an IP address (for network device testing)
const isIPAddress = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(window.location.hostname);

switch (hostname) {
    case 'localhost':
        domain = 'http://localhost:8000/';
        hostApi = 'http://localhost:8000/api/v1/';
        hostS3 = 'http://localhost:4566/';
        break;
    case 'develop':
        domain = 'https://develop.cherryclipz.com';
        hostApi = 'https://develop.cherryclipz.com/api/v1/';
        hostS3 = 'https://s3.us-east-2.amazonaws.com/';
        break;
    case 'www':
        domain = 'https://www.cherryclipz.com';
        hostApi = 'https://www.cherryclipz.com/api/v1/';
        hostS3 = 'https://s3.us-east-2.amazonaws.com';
        break;
    default:
        // Handle network IP addresses (for device testing) and unknown hostnames
        if (isIPAddress) {
            // Use the network IP for backend, but keep localhost for localstack
            domain = `http://${window.location.hostname}:8000/`;
            hostApi = `http://${window.location.hostname}:8000/api/v1/`;
            hostS3 = `http://${window.location.hostname}:4566/`;
        } else {
            // Fallback to localhost for unknown hostnames
            domain = 'http://localhost:8000/';
            hostApi = 'http://localhost:8000/api/v1/';
            hostS3 = 'http://localhost:4566/';
        }
        break;
}


console.log('domain', domain);
console.log('hostApi', hostApi);
console.log('hostS3', hostS3);

export { domain, hostApi, hostS3 };

// Development localstack, the endpoint is http://localhost:4566/
// Production localstack, the endpoint is http://localhost.localstack.cloud:4566/
console.log('domain', domain);
console.log('hostApi', hostApi);
console.log('hostS3', hostS3);

export const authUrl = {
    'get_email': `${hostApi}get-email/`,
    'get_pass': `${hostApi}get-code/`,
    'signUp': `${hostApi}sign-up/`,
}
export const getUserUrl = `${hostApi}get-user/`;

export const logoutUrl = `${hostApi}logout/`;
export const csrfUrl = `${hostApi}csrf/`;
export const getUserVideosUrl = `${hostApi}user-downloaded-videos/`;
export const downloadUrl = `${hostApi}download-videos/`;
export const uploadUrl = hostS3
export const getSentencesUrl = `${hostApi}user-create/`;
export const getSentencesStreamUrl = `${hostApi}user-create-stream/`;
export const makeVideoUrl = `${hostApi}make-video/`;
export const getMyCreationsUrl = `${hostApi}my-creations/`;
export const deleteUrl = `${hostApi}delete-downloaded-video/`;
export const host = 'http://localhost/';
export const getPagesUrl = `${hostApi}get-pages/`;
export const presignedUrlEndpoint = `${hostApi}generate-presigned-url/`;
export const updateUploadVideoData = `${hostApi}update-upload-video-data/`;
export const getUserTranscriptVideosUrl = `${hostApi}get-user-transcript-videos/`;

// Stripe URLs
export const createCheckoutSessionUrl = `${hostApi}create-checkout-session/`;
export const verifyPaymentUrl = `${hostApi}verify-payment/`;
export const createPortalSessionUrl = `${hostApi}create-portal-session/`;
export const subscriptionUrl = `${hostApi}subscription/`;
export const cancelSubscriptionUrl = `${hostApi}cancel-subscription/`;
export const getUserResourceUsageUrl = `${hostApi}get-user-resource-usage/`;
export const updateUserProfileUrl = `${hostApi}update-user-profile/`;
export const EMO_NAME = 'Emo Transcripts'
export const EMO_EMAIL = 'dr.aisaac@emotranscripts.com'
export const EMO_DOMAIN = 'www.cherryclipz.com'
// Limits

// should be more then enough for the user a 2 hours video has +/- 4000 lines
export const maxLines = 99999

export const APP_BAR_HEIGHT = 64;
export const SIZE_IN_BYTES = (3.5 * 1024 * 1024 * 1024) - 1
// check settings in django this must be sync with the frontend
export const MAX_VIDEO_SIZE_FRENDLY = converToStorageUnit(SIZE_IN_BYTES)
export const MAX_VIDEO_SIZE_BYTES = SIZE_IN_BYTES

export const BULK_SELECTION_THRESHOLD = 2; //start at 0
// 30 seconds
export const GIF_MAX_DURATION = 30000;

export const DRAG_TOOLBAR_HEIGHT = 64;
export const TIMELINE_HEIGHT = 180;
export const TIMELINE_TITLE_HEIGHT = Math.floor(TIMELINE_HEIGHT * 0.24); // 24% of timeline height

export const SENTIMENTS = { 'positive': false, 'negative': false, 'neutral': false }

export const SPACE = ' ';
export const CREATE_VIDEO = 'Create a Video'
export const CHART = 'Charts'
export const CHERRY_PICK = 'Cherry Pick'
export const SUPPORTED_VIDEO_FORMATS = ['mp4', 'webm', 'mts', 'm2ts', 'ts', 'mov', 'm4v', 'mxf'];

// messages only needs the mp4, we don't need to send the ext to tasks
// the file is created base on the original format, so all tasks need to
// know is that a video should be created task type mp4
export const optionToKind = {
    'Create a MP4 video': 'mp4',
    'Create a WEBM video': 'mp4',
    'Create a MTS video': 'mp4',
    'Create a M2TS video': 'mp4',
    'Create a TS video': 'mp4',
    'Create a MOV video': 'mp4',
    'Create a M4V video': 'mp4',
    'Create a MXF video': 'mp4',
    'Super Cut (searched words only)': 'mp4_super_cut',
    'Create a GIF': 'gif',
    'Create a SRT file': 'srt',
    'Create a VTT file': 'vtt',
    'Create zip file with all SRT\'s': 'zip_srt'
};


export const MONTH_NAMES = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

export const VIEW_DRAGABLE_BUTTONS_AIB = {
        handle: true,
        arrowUp: true,
        arrowDown: true,
        arrowLeft: true,
        arrowRight: true,
        stats: true,
        length: false,
        seconds: false,
        search: true,
        subtitles: true,
        resetFilters: true,
        createVideo: true,
        views: true,
        playClip: true,
        precision: true,
        videoWidth: true,
}

export const VIEW_DRAGABLE_BUTTONS_AUTO_HIGHLIGHT = {
    handle: true,
    arrowUp: true,
    arrowDown: true,
    arrowLeft: true,
    arrowRight: true,
    stats: true,
    length: false,
    seconds: false,
    search: true,
    subtitles: true,
    resetFilters: true,
    createVideo: true,
    views: true,
    playClip: true,
    precision: true,
    videoWidth: true,
}

export const VIEW_DRAGABLE_BUTTONS_CATEGORIES = {
    handle: true,
    arrowUp: true,
    arrowDown: true,
    arrowLeft: true,
    arrowRight: true,
    stats: true,
    length: false,
    seconds: false,
    search: true,
    subtitles: true,
    resetFilters: true,
    views: true,
    playClip: true,
    precision: true,
    videoWidth: true,
}

export const VIEW_DRAGABLE_BUTTONS_CONTENT_MODERATION = {
    handle: true,
    arrowUp: true,
    arrowDown: true,
    arrowLeft: true,
    arrowRight: true,
    stats: true,
    length: false,
    seconds: false,
    search: true,
    subtitles: false,
    spaces: true,
    resetFilters: true,
    createVideo: true,
    views: true,
    playClip: true,
    precision: true,
    videoWidth: true,
}
export const VIEW_DRAGABLE_BUTTONS_ENTITIES = {
    handle: true,
    arrowUp: true,
    arrowDown: true,
    arrowLeft: true,
    arrowRight: true,
    stats: true,
    length: false,
    seconds: false,
    resetFilters: true,
    search: true,
    createVideo: true,
    views: true,
    playClip: true,
    precision: true,
    videoWidth: true,
}

export const VIEW_DRAGABLE_BUTTONS_CHERRY_PICK = {
       handle: true,
        arrowUp: true,
        arrowDown: true,
        arrowLeft: true,
        arrowRight: true,
        stats: true,
        sentiment: true,
        speaker: true,
        length: true,
        seconds: true,
        spaces: true,
        subtitles: true,
        resetFilters: true,
        search: true,
        createVideo: true,
        views: true,
        playClip: true,
        precision: false,
        videoWidth: false,
}

export const VIEW_DRAGABLE_BUTTONS_CREATE_VIDEO = {
        handle: true,
        arrowUp: true,
        arrowDown: true,
        arrowLeft: true,
        arrowRight: true,
        stats: true,
        sentiment: true,
        speaker: true,
        spaces: true,
        length: true,
        seconds: true,
        resetFilters: true,
        search: true,
        createVideo: true,
        views: true,
        playClip: true,
        precision: true,
        subtitles: false,
        videoWidth: true,
}
    
export const VIEW_DRAGABLE_BUTTONS_WORDS = {
    handle: true,
    arrowUp: true,
    arrowDown: true,
    arrowLeft: true,
    arrowRight: true,
    stats: true,
    sentiment: false,
    speaker: false,
    length: false,
    seconds: false,
    subtitles: false,
    resetFilters: true,
    search: true,
    createVideo: true,
    views: true,
    playClip: true,
    precision: true,
    videoWidth: true,
}


export const VIEW_DRAGABLE_BUTTONS_CHART = {
        handle: true,
        arrowUp: true,
        arrowDown: true,
        arrowLeft: true,
        arrowRight: true,
        stats: true,
        sentiment: true,
        speaker: true,
        length: true,
        seconds: true,
        spaces: true,
        subtitles: false,
        resetFilters: true,
        search: true,
        createVideo: false,
        views: true,
        playClip: true,
        precision: false,
        videoWidth: false,
}

export const viewItems = [
    'Entities',
    'Auto Highlight',
    'AIB',     
    'Cherry Pick',    
    'Create a Video',
    'Content Moderation',
    'Charts',
];

export const mapViewToModel = {
    'AIB': 'aib',
    'Auto Highlight': 'autohighlight',
    'Cherry Pick': 'sentence',
    'Create a Video': 'sentence',
    'Content Moderation': 'contentmoderation',
    'Entities': 'entities',
    'Charts': 'sentence',
    'Words': 'word',
}

export const mapViewToUser = {
    'Entities': 'Entities',
    'Auto Highlight': 'Highlights',
    'AIB': 'Categories',
    'Cherry Pick': 'Cherry Pick',
    'Create a Video': 'EMO Trasncript',
    'Content Moderation': 'Content Moderation',
    'Charts': 'Charts',
}

// Owner decided in the last moment to change the name of the views to the user
export const translate = (view: string) => {
    return (mapViewToUser as Record<string, string>)[view] || view;
}


export const CURRENT_VIEW_CONFIG = {
    'AIB': VIEW_DRAGABLE_BUTTONS_AIB,
    'Auto Highlight': VIEW_DRAGABLE_BUTTONS_AUTO_HIGHLIGHT,
    'Categories': VIEW_DRAGABLE_BUTTONS_CATEGORIES,
    'Cherry Pick': VIEW_DRAGABLE_BUTTONS_CHERRY_PICK,
    'Create a Video': VIEW_DRAGABLE_BUTTONS_CREATE_VIDEO,
    'Content Moderation': VIEW_DRAGABLE_BUTTONS_CONTENT_MODERATION,
    'Entities': VIEW_DRAGABLE_BUTTONS_ENTITIES,
    'Words': VIEW_DRAGABLE_BUTTONS_WORDS,
    'Charts': VIEW_DRAGABLE_BUTTONS_CHART,
}

